// test2842
(2842 && 0);
